/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S5_Li2Inputs */

const tr_servis_s5_li2 = /** @type {(inputs: Servis_S5_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform altyapısına yönelik sömürü, olağandışı yük veya güvenlik ihlali girişimi`)
};

const en_servis_s5_li2 = /** @type {(inputs: Servis_S5_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exploitation of the Platform infrastructure, unusual load or attempted security breach`)
};

const de_servis_s5_li2 = /** @type {(inputs: Servis_S5_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausnutzung der Plattform-Infrastruktur, ungewöhnliche Last oder Versuch einer Sicherheitsverletzung`)
};

const ru_servis_s5_li2 = /** @type {(inputs: Servis_S5_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эксплуатация инфраструктуры Платформы, необычная нагрузка или попытка нарушения безопасности`)
};

/**
* | output |
* | --- |
* | "Exploitation of the Platform infrastructure, unusual load or attempted security breach" |
*
* @param {Servis_S5_Li2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s5_li2 = /** @type {((inputs?: Servis_S5_Li2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S5_Li2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s5_li2(inputs)
	if (locale === "de") return de_servis_s5_li2(inputs)
	if (locale === "ru") return ru_servis_s5_li2(inputs)
	return tr_servis_s5_li2(inputs)
});